import React from 'react';
import { message } from 'antd';
import { isEmpty } from 'lodash';
import { inject, observer } from 'mobx-react';
import { getProjectDetail } from '@gtintel/platform-api';
import { ProjectMembersChatButtons } from '@gtintel/platform-chat';
import { COOKIE_NAMES } from '@gtintel/platform-constants';
import { BatchType } from '@gtintel/platform-types';
import { getSessionStorageItem } from '@gtintel/platform-utils';
import { displayChatPopup } from './displayChatPopup';

// Copied from: apps/platform-admin/src/components/Pages/Admin/Project/Detail/utils'
function scrollHorizontal(loca) {
  if (loca !== 0) {
    this.scrollToChat.scrollTo(Number(loca) - 15, 0);
  } else {
    this.scrollToRight();
  }
}
function scrollToRight() {
  this.listpopupchat?.scrollIntoView({
    inline: 'center',
    block: 'end'
  });
}

/// apps/platform-admin/src/components/Pages/Admin/Project/Detail/utils'

class ProjectButtonsStateContainer extends React.Component {
  constructor(props) {
    super(props);
    this.displayChatPopup = void 0;
    this.scrollHorizontal = void 0;
    this.scrollToRight = void 0;
    this.openChats = channelInfo => {
      if (!this[`child${channelInfo.channelSid}`]) {
        this.displayChatPopup({
          identity: channelInfo.identity,
          channel_sid: channelInfo.channelSid,
          popupName: channelInfo.popupName,
          groupMembers: channelInfo.groupMembers,
          typeChat: 'project',
          hideHeader: false,
          isAssignmentPartnerChat: channelInfo.isAssignmentPartnerChat
        });
        setTimeout(() => {
          if (this[`child${channelInfo.channelSid}`].openChat) {
            this[`child${channelInfo.channelSid}`].openChat(channelInfo.channelSid);
          }
        }, 100);
      } else {
        if (this[`child${channelInfo.channelSid}`].closeChat) {
          this[`child${channelInfo.channelSid}`].closeChat();
        }
      }
    };
    this.state = {
      chatPopup: null,
      listChatConnecting: [],
      loading: true,
      projects: null
    };

    //chat methods
    this.scrollHorizontal = scrollHorizontal.bind(this);
    this.scrollToRight = scrollToRight.bind(this);
    this.displayChatPopup = displayChatPopup.bind(this);
  }
  static async getInitialProps({
    projectId
  }) {
    return {
      projectId
    };
  }
  componentDidMount() {
    this.fetchProjectData();
  }
  componentDidUpdate(prevProps) {
    if (this.props.projectId !== prevProps.projectId || this.props.rerenderDependency !== prevProps.rerenderDependency) {
      this.setState({
        loading: true
      }, () => {
        this.fetchProjectData();
      });
    }
  }
  async fetchProjectData() {
    const {
      adminProjectDetailStore
    } = this.props;
    try {
      // Make sure we don't hide the loading spinner false until all these
      // calls are finished, or the UI looks janky
      await Promise.all([getProjectDetail(this.props.projectId).then(res => {
        const projects = {
          ...res,
          statusDetail: res.status,
          typeBatch: res.source
        };
        this.setState({
          projects
        });
      }).catch(() => message.error('Could not load project.')), adminProjectDetailStore.fetchProjectDetail(Number(this.props.projectId)).then(() => {
        const {
          projectDetail
        } = adminProjectDetailStore;
        if (projectDetail) {
          adminProjectDetailStore.setBatchType(projectDetail.source || BatchType.STANDARD);
          adminProjectDetailStore.fetchProjectReports(projectDetail.id);
        }
      })]);
    } catch {
      message.error('An unknown error occurred.');
    } finally {
      this.setState({
        loading: false
      });
    }
  }
  render() {
    const {
      projects,
      chatPopup
    } = this.state;
    const openChats = this.openChats;
    if (!projects) return null;

    // If you're not logged in then this component shouldn't be rendered in the
    // first place - but guard against it to prevent weird errors during logout.
    const user = getSessionStorageItem(COOKIE_NAMES.INFOR_USER);
    if (!user) return null;
    const hatched = {
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10'%3E%3Cline x1='0' y1='10' x2='10' y2='0' stroke='%23ddd' stroke-width='1'/%3E%3C/svg%3E")`,
      backgroundSize: '10px 10px',
      backgroundRepeat: 'repeat',
      borderRadius: '10px'
    };
    return <div style={{
      padding: '.85em',
      marginBottom: '1em',
      overflow: 'auto',
      height: '88px',
      ...hatched
    }}>
        {this.state.loading || isEmpty(projects) ? <></> : <ProjectMembersChatButtons onConnect={channel => openChats(channel)} project={projects} user={user} enableAssignmentChats />}
        {chatPopup}
      </div>;
  }
}
export default inject('adminProjectDetailStore')(inject('partnerStore')(observer(ProjectButtonsStateContainer)));